module.exports = __webpack_public_path__ + "img/creators__cover.a520c84c.png";